import { NavLink } from 'react-router-dom';
import { Sparkles, CreditCard, Info, Home, Play, ArrowRight, Server, Compass } from 'lucide-react';
import { BBotLogo } from '@/components/branding';
import { Button } from '@/components/ui/Button';
import { cn } from '@/lib/utils';

const menuItems = [
  { path: '/', label: 'Home', icon: Home },
  { path: '/features', label: 'Features', icon: Sparkles },
  { path: '/demo', label: 'Demo', icon: Play },
  { path: '/pricing', label: 'Pricing', icon: CreditCard },
  { path: '/enterprise', label: 'Enterprise', icon: Server },
  { path: '/vision', label: 'Vision', icon: Compass },
  { path: '/about', label: 'About', icon: Info },
];

export function Sidebar() {
  return (
    <aside className="hidden md:flex flex-col w-64 border-r border-slate-600/20 bg-slate-800/80 shadow-inner-highlight z-20">
      <NavLink to="/" className="p-6 border-b border-slate-600/20">
        <div className="flex items-center gap-3 cursor-pointer">
          <BBotLogo size="w-7 h-7" />
          <span className="font-bold text-xl leading-7 bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-400">
            DialogMe
          </span>
        </div>
      </NavLink>

      <div className="flex-1 p-4 space-y-2 overflow-y-auto">
        <div className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-3 px-2">
          Menu
        </div>
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              className={({ isActive }) =>
                cn(
                  'w-full text-left text-sm font-medium px-3 py-2 rounded-lg flex items-center gap-3 transition-colors',
                  isActive
                    ? 'bg-indigo-500/10 text-indigo-300 border border-indigo-500/20 shadow-sm shadow-indigo-500/10'
                    : 'text-slate-400 hover:text-white hover:bg-slate-700/50'
                )
              }
            >
              <Icon className="w-4 h-4" />
              {item.label}
            </NavLink>
          );
        })}
      </div>

      <div className="p-4 border-t border-slate-600/20 bg-slate-800/50 space-y-4">
        <a href="https://console.dialogme.ai" target="_blank" rel="noopener noreferrer">
          <Button variant="primary" className="w-full" leftIcon={<ArrowRight className="w-4 h-4" />}>
            Get Access
          </Button>
        </a>
        <div className="flex gap-3 px-2">
          <NavLink to="/terms" className="text-[10px] text-slate-600 hover:text-slate-400 transition-colors">
            Terms
          </NavLink>
          <NavLink to="/privacy" className="text-[10px] text-slate-600 hover:text-slate-400 transition-colors">
            Privacy
          </NavLink>
          <NavLink to="/investors" className="text-[10px] text-slate-600 hover:text-slate-400 transition-colors">
            For Investors
          </NavLink>
        </div>
        <div className="px-2 text-[10px] text-slate-600">
          &copy; {new Date().getFullYear()} DialogMe Inc.
        </div>
      </div>
    </aside>
  );
}
